import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import Button from "components/Button";
import { useTranslation } from "react-i18next";

const WelcomeBack: FC<Props> = ({ nextStep }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.title}>{t("welcomeBack.title")}</div>

        <div className={styles.side}>
          {t("welcomeBack.message")}
        </div>
      </div>
      <div className={styles.text}></div>

      <div className={styles.buttons}>
        <Button
          className={styles.button}
          text={t("welcomeBack.finishRegistration")}
          onClick={() => nextStep()}
        ></Button>
      </div>
    </div>
  );
};

export default WelcomeBack;
